"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionRoutes = void 0;
var PermissionRoutes;
(function (PermissionRoutes) {
    PermissionRoutes["BasePrefix"] = "permissions";
    PermissionRoutes["ById"] = ":permissionId";
    PermissionRoutes["ByRolePermissionId"] = ":rolePermissionId";
    PermissionRoutes["GetAll"] = "all";
    PermissionRoutes["GetList"] = "list";
})(PermissionRoutes = exports.PermissionRoutes || (exports.PermissionRoutes = {}));
